import { useState } from "react";
import { Link } from "react-router-dom";
import { ShieldCheck, Loader2, MailCheck } from "lucide-react";
import { adminApi, formatApiError } from "../adminApi";

const FIELD = "w-full rounded-lg border border-[#E5E7EB] px-4 py-3 text-[#1F2937] focus:outline-none focus:border-[#1E88E5] focus:ring-2 focus:ring-[#1E88E5]/20 transition";

export default function AdminForgotPassword() {
  const [email, setEmail] = useState("");
  const [sent, setSent] = useState(false);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  const onSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError("");
    try {
      await adminApi.post("/auth/forgot-password", { email: email.trim() });
      setSent(true);
    } catch (err) {
      setError(formatApiError(err.response?.data?.detail));
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-[#0A2342] flex items-center justify-center px-6" data-testid="admin-forgot-page">
      <div className="w-full max-w-md">
        <div className="flex items-center justify-center gap-3 mb-8">
          <ShieldCheck className="text-[#1E88E5]" size={28} />
          <span className="text-white font-heading font-bold tracking-wide">MERIDIAN VANGUARD ADMIN</span>
        </div>
        <div className="bg-white rounded-xl p-8 shadow-xl">
          {sent ? (
            <div className="text-center" data-testid="forgot-success">
              <MailCheck className="mx-auto text-[#1E88E5]" size={40} />
              <h1 className="mt-4 font-heading text-xl font-bold text-[#0A2342]">Check your email</h1>
              <p className="mt-2 text-sm text-[#4B5563]">If an account exists for that email, we've sent a password reset link. It expires in 1 hour.</p>
              <Link to="/admin/login" className="mt-6 inline-block text-sm text-[#1E88E5] hover:underline">Back to sign in</Link>
            </div>
          ) : (
            <>
              <h1 className="font-heading text-2xl font-bold text-[#0A2342]">Forgot password</h1>
              <p className="mt-1 text-sm text-[#4B5563]">Enter your admin email and we'll send you a reset link.</p>
              <form onSubmit={onSubmit} className="mt-6 space-y-4" noValidate>
                <input data-testid="forgot-email" className={FIELD} type="email" value={email} onChange={(e) => setEmail(e.target.value)} placeholder="you@example.com" />
                {error && <p className="text-sm text-red-700">{error}</p>}
                <button data-testid="forgot-submit" type="submit" disabled={loading} className="w-full flex items-center justify-center gap-2 rounded-lg bg-[#0A2342] text-white py-3 font-semibold hover:bg-[#1E88E5] transition-colors disabled:opacity-60">
                  {loading && <Loader2 size={18} className="animate-spin" />} Send Reset Link
                </button>
              </form>
              <div className="mt-4 text-center">
                <Link to="/admin/login" className="text-sm text-[#1E88E5] hover:underline">Back to sign in</Link>
              </div>
            </>
          )}
        </div>
      </div>
    </div>
  );
}
